module.exports = __webpack_public_path__ + "static/img/Jordan_De_Goey_mobile.cc47ff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan_De_Goey_mobile.jpg
// module id = 51xP
// module chunks = 0